import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExceptionInfo } from '../../../../models/session.model';

@Component({
  selector: 'app-session-crash-panel',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="exception" class="absolute top-20 left-4 w-96 bg-black border border-red-500/30 rounded-none overflow-hidden shadow-pixel z-20 pointer-events-auto transition-all">
      <div class="bg-red-500/20 px-4 py-3 border-b border-red-500/30 flex items-center gap-3">
        <div class="w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center text-red-400">
          <i class="ph ph-skull text-lg"></i>
        </div>
        <div>
          <h3 class="text-red-400 font-bold text-sm">Application Crash</h3>
          <p class="text-[10px] text-red-400/70 font-mono uppercase">{{ exception.type || 'FATAL EXCEPTION' }}</p>
        </div>
      </div>
      <div class="p-4 flex flex-col gap-3">
        <div>
          <span class="text-[10px] text-gray-400 uppercase tracking-wider font-bold">Exception</span>
          <p class="text-white text-sm font-mono break-all">{{ exception.exceptionName }}</p>
        </div>
        <div>
          <span class="text-[10px] text-gray-400 uppercase tracking-wider font-bold">Mensaje</span>
          <p class="text-red-300 text-sm italic">{{ exception.exceptionMessage }}</p>
        </div>
        <div>
          <span class="text-[10px] text-gray-400 uppercase tracking-wider font-bold">Thread</span>
          <p class="text-gray-300 text-xs">{{ exception.threadName }}</p>
        </div>
        <div class="mt-1">
          <span class="text-[10px] text-gray-400 uppercase tracking-wider font-bold mb-1 block">Stacktrace</span>
          <div class="bg-black border border-zaxis-border rounded-none p-2 max-h-64 overflow-y-auto custom-scrollbar">
            <pre class="text-[10px] text-gray-300 whitespace-pre-wrap font-mono">{{ exception.stackTrace }}</pre>
          </div>
        </div>
      </div>
    </div>
  `
})
export class SessionCrashPanelComponent {
  @Input() exception?: ExceptionInfo | null;
}
